export default __webpack_public_path__ + "static/media/gallery_03.3417efb7.jpg";